import React from "react";
import { Card, Dropdown, Button } from "antd";
import { MoreOutlined, ReloadOutlined, ExpandOutlined, DragOutlined } from "@ant-design/icons";

const WidgetWrapper = ({
    title,
    children,
    extra,
    loading = false,
    onRefresh,
    menuActions = [],
    className,
    style,
    showTitle = true,
    showMenu = true,
    isEditing,
    onRequestResize,
    headStyle: customHeadStyle,
    bordered,
    ...cardProps
}) => {
    const defaultMenuItems = [
        {
            key: "refresh",
            label: "刷新",
            icon: <ReloadOutlined />,
            onClick: onRefresh,
            disabled: !onRefresh,
        },
    ];

    const menuItems = [...menuActions, ...defaultMenuItems];

    return (
        <Card
            title={showTitle ? title : null}
            size="small"
            className={`widget-card ${className || ""} ${showTitle ? "widget-with-title" : "widget-no-title"}`}
            style={{ height: "100%", display: "flex", flexDirection: "column", ...style }}
            loading={loading}
            extra={
                showTitle && showMenu ? (
                    <div className="widget-actions">
                        {extra}
                        <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                            <Button type="text" icon={<MoreOutlined style={{ color: "var(--text-secondary)" }} />} size="small" />
                        </Dropdown>
                    </div>
                ) : null
            }
            styles={{
                header: {
                    backgroundColor: "var(--widget-bg, #fff)",
                    borderBottom: "1px solid var(--border-color-split, #f0f0f0)",
                    ...customHeadStyle,
                },
            }}
            variant={bordered === false ? "borderless" : undefined}
            {...cardProps}
        >
            {!showTitle && showMenu && (
                <div className="widget-actions-floating">
                    {extra}
                    <Dropdown menu={{ items: menuItems }} placement="bottomRight">
                        <Button type="text" icon={<MoreOutlined style={{ color: "var(--text-secondary)" }} />} size="small" />
                    </Dropdown>
                </div>
            )}
            {!showTitle && isEditing && (
                <div className="widget-drag-handle widget-drag-handle-icon">
                    <DragOutlined />
                </div>
            )}
            {children}
        </Card>
    );
};

export default WidgetWrapper;
